import styled from 'styled-components';
import { ELLIPSIS } from '@optimus-web/core';

export const EllipsizedSpan = styled.span`
    ${ELLIPSIS}
`;
